import {AbstractControl, Form, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function missingFeatureSeverityValidator(fg: FormGroup): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const feedbackTypeControl = fg.get('feedbackType');
    if (feedbackTypeControl) {
      const feedbackType = feedbackTypeControl.value;
      if (feedbackType != "MissingFeature") {
        return null;
      } else {
        if (control.value != "Unknown") {
          return null;
        }
        return {"MissingFeatureSeverityMustBeSet": true};
      }
    }
    return null;
  }
}
